import { Upload, message } from 'antd';
import { useEffect, useState } from 'react';

import { useS3Upload } from 'lib/s3';
import { CameraOutlined, LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

const beforeUpload = (file) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }
  return isJpgOrPng && isLt2M;
};

export function SpImgUploadAvatar({ defaults = '', style = null, onChange }) {
  const [fileUrl, setFileUrl] = useState('');

  const onPresentFiles = (files) => {
    setFileUrl(files);
    onChange?.(files);
  };

  const { mutate, forceRequest, isPending } = useS3Upload({
    onSuccess: (res) => {
      onPresentFiles(res?.url);
      message.success(`อัปโหลดไฟล์ (${res?.file_name}) สำเร็จ`);
    },
    onError: () => {
      setFileUrl('');
      message.error('ไม่สามารถอัปโหลดไฟล์นี้ได้ กรุณาลองใหม่อีกครั้ง');
    },
  });

  const onUploadChange = async ({ file }) => {
    if (file.status === 'done') {
      await mutate({
        file: file.originFileObj,
        module: 'online_scam',
        group: 'case',
        uid: file.uid,
      });
    }
  };

  useEffect(() => {
    if (defaults) {
      setFileUrl(defaults);
    }
  }, [defaults]);

  return (
    <UploadComponent
      name="avatar"
      listType="picture-card"
      showUploadList={false}
      customRequest={forceRequest}
      beforeUpload={beforeUpload}
      onChange={onUploadChange}
      style={style}
    >
      {fileUrl ? (
        <img
          src={fileUrl}
          alt="avatar"
          style={{
            width: '100%',
          }}
        />
      ) : (
        <UploadButton loading={isPending} />
      )}
    </UploadComponent>
  );
}

function UploadButton({ loading }) {
  return (
    <div>
      {loading ? <LoadingOutlined /> : <CameraOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
}

const UploadComponent = styled(Upload)((props) => ({
  textAlign: 'center',
  '.ant-upload.ant-upload-select-picture-card': props.style,
}));
